import React from 'react';
import { Link } from 'react-router-dom';
import { FIRM, NAV_LINKS } from '../data/siteData';

export default function Footer() {
  const taxLinks   = NAV_LINKS.find(l => l.label === 'Tax Matters')?.children || [];
  const legalLinks = NAV_LINKS.find(l => l.label === 'Legal Matters')?.children || [];
  const corpLinks  = NAV_LINKS.find(l => l.label === 'Corporate')?.children || [];
  const immLinks   = NAV_LINKS.find(l => l.label === 'Immigration')?.children || [];

  return (
    <footer className="bg-navy-dark pt-16 pb-8">
      <div className="px-[5%]">
        {/* Top Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-white/10">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-4 no-underline">
           <img src={FIRM.footer_logo} alt="Logo" className="h-20 w-auto object-contain" style={{ mixBlendMode: 'screen' }} />
              <div>
                <div className="font-serif font-bold text-white text-base leading-tight">{FIRM.name}</div>
                <div className="text-[0.6rem] text-white/40 uppercase tracking-[0.14em]">{FIRM.tagline}</div>
              </div>
            </Link>
            <p className="text-white/40 text-sm leading-relaxed mb-5">
              Pakistan's premier multi-disciplinary consultancy firm providing expert tax, legal, corporate, and immigration services since {FIRM.established}.
            </p>
            <div className="flex gap-2">
              {['f', 'in', 'tw', 'yt'].map(s => (
                <a key={s} href="#"
                  className="w-8 h-8 bg-white/10 flex items-center justify-center text-white/50 text-xs rounded-sm hover:bg-gold hover:text-white transition-colors">
                  {s}
                </a>
              ))}
            </div>
          </div>

          {/* Tax */}
          <FooterCol title="Tax Matters" links={taxLinks} />
          {/* Legal + Corp combined */}
          <FooterCol title="Legal & Corporate" links={[...legalLinks.slice(0,3), ...corpLinks.slice(0,3)]} />
          {/* Immigration */}
          <FooterCol title="Immigration" links={immLinks} />
        </div>

        {/* Bottom */}
        <div className="pt-6 flex flex-wrap justify-between items-center gap-3">
          <p className="text-white/30 text-xs">© {new Date().getFullYear()} {FIRM.name}. All rights reserved.</p>
          <p className="text-white/30 text-xs">
            📞 <a href={`tel:${FIRM.phone}`} className="text-gold-light hover:underline">{FIRM.phone}</a>
            &nbsp;|&nbsp;
            <a href={`mailto:${FIRM.email}`} className="text-gold-light hover:underline">{FIRM.email}</a>
          </p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h4 className="font-serif font-semibold text-white text-sm mb-4 pb-2 border-b-2 border-gold inline-block">
        {title}
      </h4>
      <ul className="list-none space-y-2">
        {links.map(link => (
          <li key={link.path}>
            <Link to={link.path}
              className="text-white/40 text-xs hover:text-gold-light transition-colors flex items-center gap-1">
              <span className="text-gold">›</span> {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
